const DEBUG = document.body.dataset.debug !== undefined;

const WLCart = {
    generateBuildLinkId: function() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      return `build-${Date.now()}-${Math.floor(Math.random() * 1000000000)}`;
    },

    /**
     * cart/change 用。_build_price_target 等を削除したあと properties が空になると Shopify 側で更新が無視されるためプレースホルダーを付与する。
     */
    normalizeLineItemPropertiesForCartChange(properties) {
      const next = { ...properties };
      Object.keys(next).forEach((key) => {
        if (next[key] === null || next[key] === undefined) {
          delete next[key];
        }
      });
      if (Object.keys(next).length === 0) {
        next._build_price_cleared = '1';
      }
      return next;
    },

    /**
     * 親商品指定セットで組立料行を削除するとき、同一セットの子すべてから _is_build_option / _buildTrue / _build_price_target をまとめて外す。
     * updateRelatedBuildOptionFlags と分離し、1 リクエストで送ることでフラグ更新後に古いスナップショットで上書きしない。
     */
    async updateRelatedSetItemsWhenRemovingParentBuildPrice(cartData, buildPriceItem, buildPriceVariantId) {
      if (!buildPriceItem.properties || !buildPriceItem.properties._set_key) return;

      const setKey = buildPriceItem.properties._set_key;
      const baseSetKey = setKey.replace('_buildTrue', '');

      const relatedItems = cartData.items.filter((item) => {
        if (item.variant_id.toString() === buildPriceVariantId) return false;

        const itemSetKey = item.properties && item.properties._set_key;
        if (!itemSetKey) return false;

        const itemBaseSetKey = itemSetKey.replace('_buildTrue', '');
        return itemBaseSetKey === baseSetKey;
      });

      for (const item of relatedItems) {
        const updatedProperties = { ...item.properties };

        delete updatedProperties._is_build_option;
        delete updatedProperties._build_price_target;
        delete updatedProperties._build_link_id;

        if (updatedProperties._set_key && updatedProperties._set_key.includes('_buildTrue')) {
          updatedProperties._set_key = updatedProperties._set_key.replace('_buildTrue', '');
        }

        try {
          await fetch(`${theme.routes.cart_change_url}`, {
            ...fetchConfig(),
            body: JSON.stringify({
              id: item.key,
              quantity: item.quantity,
              properties: this.normalizeLineItemPropertiesForCartChange(updatedProperties),
            }),
          });
        } catch (error) {
          console.error('親商品指定セットの組立関連プロパティ更新エラー:', error);
        }
      }
    },

    // 組み立て商品削除時の関連商品フラグ更新処理（共通化）
    async updateRelatedBuildOptionFlags(cartData, optionsOrVariantId, excludeVariantIds = []) {
      const options = typeof optionsOrVariantId === 'object'
        ? optionsOrVariantId
        : { sourceVariantId: optionsOrVariantId, excludeVariantIds };
      const sourceItemKey = options && options.sourceItemKey ? options.sourceItemKey : null;
      const sourceVariantId = options && options.sourceVariantId ? String(options.sourceVariantId) : null;
      const excludedVariantIds = options && options.excludeVariantIds ? options.excludeVariantIds.map(String) : [];
      const excludedKeys = options && options.excludeKeys ? options.excludeKeys : [];

      const item = sourceItemKey
        ? cartData.items.find((cartItem) => cartItem.key === sourceItemKey)
        : cartData.items.find((cartItem) => cartItem.variant_id.toString() === sourceVariantId);
      if (!item || !item.properties || !item.properties._set_key) return;

      const setKey = item.properties._set_key;
      const baseSetKey = setKey.replace('_buildTrue', '');
      
      // 関連する商品を探す（除外リストの商品は除外）
      const relatedItems = cartData.items.filter(item => {
        if (excludedKeys.includes(item.key)) return false;
        if (excludedVariantIds.includes(item.variant_id.toString())) return false;
        
        const itemSetKey = item.properties && item.properties._set_key;
        if (!itemSetKey) return false;
        
        const itemBaseSetKey = itemSetKey.replace('_buildTrue', '');
        return itemBaseSetKey === baseSetKey;
      });
      
      // 関連商品のプロパティを更新
      for (const item of relatedItems) {
        const updatedProperties = { ...item.properties };
        
        // _is_build_optionフラグを削除
        delete updatedProperties._is_build_option;
        
        // _set_keyから_buildTrueサフィックスを削除
        if (updatedProperties._set_key && updatedProperties._set_key.includes('_buildTrue')) {
          updatedProperties._set_key = updatedProperties._set_key.replace('_buildTrue', '');
        }
        
        try {
          await fetch(`${theme.routes.cart_change_url}`, {
            ...fetchConfig(),
            body: JSON.stringify({
              id: item.key,
              quantity: item.quantity,
              properties: updatedProperties
            })
          });
        } catch (error) {
          console.error('関連商品フラグ更新エラー:', error);
        }
      }
    },
    buildPriceSKUs: [
      "U90000003000000Z0442",  // 現地組立料（¥4,950）
      "U90000003000000Z0438",  // 現地組立料（¥2,200）
      "U90000003000000Z0439",  // 現地組立料（¥3,300）
      "U90000003000000Z0437",  // 現地組立料（¥1,650）
      "U90000003000000Z0440",  // 現地組立料（¥4,400）
      "U90000003000000Z0441",  // 現地組立料（¥6,600）
      "U90000003000000Z0190",  // 現地組立料（¥1,650）
      "U90000000000000Z0000",  // 現地組立料（¥1,100）
      "U90000003000000Z0022",  // 現地組立料（¥1,650）
      "U90000003000000Z0020",  // 現地組立料（¥1,650）
      "U90000003000000Z0021"   // 現地組立料（テーブル）
    ],
    estimateErrorType1And5Products: [],
    estimateErrorType2And3Products: [],
    estimateErrorType4Products: [],
    estimateErrorType6Products: [],
    shippingCategoryLock: false,

    getSectionsToRender: function() {
      return [
        {
          id: "wl-main-cart-items",
          section: document.getElementById("wl-main-cart-items") ? document.getElementById("wl-main-cart-items").dataset.id : "",
        },
        {
          id: "wl-gift-wrapping",
          section: document.getElementById("wl-main-cart-items") ? document.getElementById("wl-main-cart-items").dataset.id : "",
        },
        {
          id: "wl-cart-total",
          section: document.getElementById("wl-main-cart-items") ? document.getElementById("wl-main-cart-items").dataset.id : "",
        },
        {
          id: "wl-cart-attention",
          section: document.getElementById("wl-main-cart-items") ? document.getElementById("wl-main-cart-items").dataset.id : "",
        },
        {
          id: "wl-novelty",
          section: document.getElementById("wl-main-cart-items") ? document.getElementById("wl-main-cart-items").dataset.id : "",
        },
        {
          id: "wl-button-area",
          section: document.getElementById("wl-main-cart-items") ? document.getElementById("wl-main-cart-items").dataset.id : "",
        },
        {
          id: "wl-cart-banner-area",
          section: document.getElementById("wl-main-cart-items") ? document.getElementById("wl-main-cart-items").dataset.id : "",
        },
        {
          id: "wl-mini-cart",
          section: document.getElementById("wl-mini-cart") ? document.getElementById("wl-mini-cart").dataset.id : "",
        },
        {
          id: "wl-header",
          section: document.querySelector('unico-header') ? document.querySelector('unico-header').dataset.id : "",
        }
      ];
    },

    /**
     * Find consumingPoints.js script URL from DOM
     * @param {Document} searchDocument - Document to search in (default is document)
     * @returns {string|null} Script URL or null if not found
     */
    findConsumingPointsScriptUrl: function(searchDocument = document) {
      // Find all script tags
      const scripts = searchDocument.querySelectorAll('script[src]');
      
      for (const script of scripts) {
        const src = script.getAttribute('src');
        if (src && src.includes('consumingPoints.js')) {
          return src;
        }
      }
      
      return null;
    },

    /**
     * Reload script from URL after DOM is rendered
     * @param {string} scriptUrl - Script URL to reload
     */
    reloadScript: function(scriptUrl) {
      if (!scriptUrl) {
        console.warn('Script URL not found, skipping reload');
        return;
      }

      // Remove old script if exists (search by pattern instead of exact match)
      const existingScripts = document.querySelectorAll('script[src]');
      existingScripts.forEach(script => {
        const src = script.getAttribute('src');
        if (src && src.includes('consumingPoints.js')) {
          script.remove();
        }
      });

      // Create new script tag
      const script = document.createElement('script');
      script.src = scriptUrl;
      script.type = 'text/javascript';
      script.defer = true;
      
      // Append to head or body
      (document.head || document.body).appendChild(script);
    },

    renderNewSections: function(sections, updateShippingCategory = true) {
      this.getSectionsToRender().forEach((s) => {
        const oldNode = document.getElementById(s.id);
        if (!oldNode) {
          WLCommon.disableLoading();
          return;
        }
        const newNode = new DOMParser().parseFromString(
          sections[s.section],
          "text/html"
        );
        if (s.id === "wl-header") {
          // oldNode.querySelector('#wishlist-num').innerHTML = newNode.querySelector('#wishlist-num').innerHTML;
          oldNode.querySelector('#cart-num').outerHTML = newNode.querySelector('#cart-num').outerHTML;
        } else if(s.id === "wl-main-cart-items") {
          oldNode.outerHTML = newNode.querySelector(`#${s.id}`).outerHTML;
          // 単品購入の商品だけが残っている場合、削除して画面をリロード
          this.deleteSinglePurchaseAvailableItems();
        } else {
          oldNode.innerHTML = newNode.querySelector(`#${s.id}`).innerHTML;
        }
      });
      if(updateShippingCategory == true) {
        WLCart.addShippingCategory();
      }
      if (this.estimateErrorType1And5Products.length ||
          this.estimateErrorType2And3Products.length ||
          this.estimateErrorType4Products.length ||
          this.estimateErrorType6Products.length) {
        this.showEstimateErrors();
      }
    },

    updateSetQuantity: function(quantity, elem) {
        WLCommon.enableLoading();

        const setKey = elem.closest('[data-set-key]').dataset.setKey;
        const changeQuantity = !quantity ? 0 : parseInt(quantity) / elem.dataset.step;
    
        fetch(`${theme.routes.cart_url}.js`)
          .then((response) => response.json())
          .then((data) => {
            const updateProductObj = {
              updates: {},
              sections: this.getSectionsToRender().map((s) => s.section),
              sections_url: window.location.pathname,
            };
    
            // 親商品と子商品の数量を変更
            data.items.forEach((item) => {
              const properties = item.properties;
              if (properties._set_key === setKey) {
                if (properties._is_parent) {
                  updateProductObj.updates[item.key] = changeQuantity;
                } else if (properties._is_set_product) {
                  updateProductObj.updates[item.key] =
                    item.properties._variant_quantity_step * changeQuantity;
                } else if (properties._is_build_price) {
                  updateProductObj.updates[item.key] = changeQuantity;
                }
              }
            });
    
            const body = JSON.stringify(updateProductObj);
    
            fetch(`${theme.routes.cart_update_url}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body,
            })
              .then((response) => response.json())
              .then((response) => {
                if(response.errors) {
                  this.updateCartItemsSection(response.errors);
                } else {
                  this.renderNewSections(response.sections);
                  if(location.pathname.includes('/cart')) {
                    window.scrollTo(0, 0);
                  }
                }
              })
              .catch(() => {
                this.errorCartUpdate();
              });
          }).catch(() => {
            this.errorCartUpdate();
          }).finally(() => {
            WLCommon.disableLoading();
          });
    },

    updateBuildPriceTargetQuantity: async function(quantity, elem) {
      try {
        WLCommon.enableLoading();

        // フィルタ・フラグ更新用は親行の variant_id、updates 用は line item key を使用
        const targetRow = elem.closest('[data-build-price-target]');
        const variantId = targetRow.dataset.variantId;
        const variantKey = elem.dataset.variantKey;
        const buildPriceId = targetRow.dataset.buildPriceTarget;
        const buildLinkId = targetRow.dataset.buildLinkId;

        // カートの現在の状態を取得
        const cartResponse = await fetch(`${theme.routes.cart_url}.js`);
        const cartData = await cartResponse.json();

        // 削除前に関連商品フラグを更新
        if (quantity === 0) {
          await this.updateRelatedBuildOptionFlags(cartData, {
            sourceItemKey: variantKey,
            sourceVariantId: variantId,
            excludeVariantIds: [variantId, buildPriceId],
            excludeKeys: [variantKey],
          });
        }

        // 関連する組立料行を特定（_build_link_id 優先、未設定時は従来ロジックにフォールバック）
        const relatedBuildPriceItems = cartData.items.filter(item =>
          item.properties &&
          item.properties._is_build_price &&
          (
            (buildLinkId && item.properties._build_link_id && String(item.properties._build_link_id) === buildLinkId) ||
            (!buildLinkId && (item.properties._build_target_variant === variantId || item.variant_id.toString() === buildPriceId))
          )
        );

        const updates = {};
        updates[variantKey] = quantity; // 対象商品の数量更新（line item key を使用）
        
        // 関連する組立商品をすべて削除
        relatedBuildPriceItems.forEach(buildItem => {
          updates[buildItem.key] = quantity;
        });

        const body = JSON.stringify({
          updates: updates,
          sections: this.getSectionsToRender().map((s) => s.section),
          sections_url: window.location.pathname,
        });

        const response = await fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        const responseData = await response.json();
        
        if(responseData.errors) {
          this.updateCartItemsSection(responseData.errors);
        } else {
          this.renderNewSections(responseData.sections);
        }
      } catch (error) {
        this.errorCartUpdate(error);
      } finally {
        WLCommon.disableLoading();
      }
    },

    updateBuildPriceQuantity: async function(quantity, elem) {
      try {
        WLCommon.enableLoading();

        const variantKey = elem.dataset.variantKey;

        // 削除前にカートの現在の状態を取得
        const cartResponse = await fetch(`${theme.routes.cart_url}.js`);
        const cartData = await cartResponse.json();
        
        // 削除対象の組立料金商品を特定（keyを使用）
        const buildPriceItem = cartData.items.find(item => item.key === variantKey);
        
        if (!buildPriceItem) {
          this.updateQuantity(quantity, elem);
          WLCommon.disableLoading();
          return;
        }

        // 組み立て商品削除時、先に関連する商品のフラグを更新（variant_id で検索するため buildPriceItem.variant_id を使用）
        if (quantity === 0) {
          const buildPriceVariantId = buildPriceItem.variant_id.toString();
          const buildLinkId = buildPriceItem.properties ? buildPriceItem.properties._build_link_id : null;
          const isParentBuildTarget =
            buildPriceItem.properties &&
            String(buildPriceItem.properties._build_target_variant) === 'parent';

          if (isParentBuildTarget) {
            await this.updateRelatedSetItemsWhenRemovingParentBuildPrice(
              cartData,
              buildPriceItem,
              buildPriceVariantId
            );
          } else {
            await this.updateRelatedBuildOptionFlags(cartData, {
              sourceItemKey: buildPriceItem.key,
              sourceVariantId: buildPriceVariantId,
              excludeVariantIds: [buildPriceVariantId],
              excludeKeys: [buildPriceItem.key],
            });

            // updateRelatedBuildOptionFlags の更新で line item key が変わる可能性があるため、最新カートを取り直してから _build_price_target を削除する
            const latestCartResponse = await fetch(`${theme.routes.cart_url}.js`);
            const latestCartData = await latestCartResponse.json();

            // この組立料に紐づく行をすべてクリア（_build_link_id 優先、未設定時は _build_price_target でフォールバック）
            const itemsToClear = latestCartData.items.filter(
              (item) =>
                item.key !== buildPriceItem.key &&
                item.properties &&
                (
                  (buildLinkId && item.properties._build_link_id && String(item.properties._build_link_id) === String(buildLinkId)) ||
                  (!buildLinkId &&
                    item.properties._build_price_target != null &&
                    String(item.properties._build_price_target) === buildPriceVariantId)
                )
            );

            for (const targetItem of itemsToClear) {
              const cleared = {
                ...targetItem.properties,
                _build_price_target: null,
                _build_link_id: null,
              };
              try {
                await fetch(`${theme.routes.cart_change_url}`, {
                  ...fetchConfig(),
                  body: JSON.stringify({
                    id: targetItem.key,
                    quantity: targetItem.quantity,
                    properties: this.normalizeLineItemPropertiesForCartChange(cleared),
                  }),
                });
              } catch (error) {
                console.error('_build_price_target クリアエラー:', error);
              }
            }
          }
        }
        
        // 最後に数量の更新（組み立て料金商品の削除）
        await this.updateQuantity(quantity, elem);

      } catch (error) {
        this.errorCartUpdate(error);
      }
    },

    updateQuantity: function(quantity, elem) {
      WLCommon.enableLoading();
      
      const variantKey = elem.dataset.variantKey;
      
      const body = JSON.stringify({
          "updates": {
            [variantKey]: quantity,
          },
          sections: this.getSectionsToRender().map((s) => s.section).filter(n => n),
          sections_url: window.location.pathname,
      });

      return fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((response) => {
        if(response.errors) {
          this.updateCartItemsSection(response.errors);
        } else {
          this.renderNewSections(response.sections);
        }
        WLCart.addShippingCategory();
      })
      .catch(() => {
        this.errorCartUpdate();
      })
      .finally(() => {
        WLCommon.disableLoading();
      });
    },

    updateCartItemsSection: function(errors)  {
      const sections = this.getSectionsToRender().map((s) => s.section).join("&sections[]=");
      return fetch(`?${sections}`)
        .then((response) => response.json())
        .then((response) => {
          this.renderNewSections(response);

          if(errors) document.querySelector('[data-modal-target="wl-cart-error-control"]').click();
        })
        .catch((e) => {
          document.querySelector('[data-modal-target="wl-cart-error-control"]').click();
        });
    },

    deleteShippingCategory: function() {
      return new Promise(async (resolve, reject) => {
        if (window.location.pathname.includes("/account/login")) {
          
        }
        WLCommon.disableLoading();
        resolve();
      });
    },
    getCart: () => {
      return new Promise((resolve, reject) => {
        fetch(`${theme.routes.cart_url}.js`)
          .then((response) => response.json())
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    addShippingCategory: async function(e) {
      if(e) {
        e.preventDefault();
      }
      
      if (this.shippingCategoryLock) {
        console.log('配送区分処理実行中のため待機');
        // Queue a single rerun instead of dropping the call. addShippingCategory rebuilds
        // all shipping lines from scratch (delete-then-add, idempotent), so re-running once
        // after the in-flight call is safe and guarantees the final rebuild uses the latest
        // DOM — e.g. after pre-order property injection changes line item keys. Dropping the
        // call (the old behaviour) could discard exactly that corrective rebuild and leave a
        // stale _target_variant_id, forcing the shopper through repeated checkout retries.
        this.shippingCategoryRerun = true;
        return;
      }

      this.shippingCategoryLock = true;
      this.shippingCategoryRerun = false;

      try {
        WLCommon.enableLoading();
      const cart = await this.getCart();
      const items = cart.items ? cart.items : [];

      // Check if DOM is stale compared to cart API
      const domItems = Array.from(document.querySelectorAll('.unico-cart-list-item'))
        .filter(el => el.dataset.shippingCategoryId);
      const cartRealItems = items.filter(
        i => !i.properties._shipping_category && !i.properties._is_build_price
      );
      const realItemsStale = domItems.length !== cartRealItems.length ||
        domItems.some(el => {
          const cartItem = cartRealItems.find(i => i.key === el.dataset.lineItemKey);
          return !cartItem || cartItem.quantity !== parseInt(el.dataset.quantity, 10);
        });

      // Assembly fee lines also affect which shipping category the real product
      // renders with (with/no assembly) — a fee added or removed elsewhere (e.g.
      // the submit-time reconciliation) without a full DOM re-render must count
      // as stale too, or the rebuild below would reuse the outdated category.
      const domFeeItems = Array.from(document.querySelectorAll('.unico-cart-list-item'))
        .filter(el => el.dataset.buildPrice === 'true');
      const cartFeeItems = items.filter(i => String(i.properties._is_build_price) === 'true');
      const feesStale = domFeeItems.length !== cartFeeItems.length ||
        domFeeItems.some(el => {
          const cartItem = cartFeeItems.find(i => i.key === el.dataset.lineItemKey);
          return !cartItem || cartItem.quantity !== parseInt(el.dataset.quantity, 10);
        });

      const domStale = realItemsStale || feesStale;

      const onCartPage = window.location.pathname.includes('/cart');

      if (domStale) {
        if (DEBUG && onCartPage) console.log('[addShippingCategory] DOM is stale — syncing sections before rebuild', {
          dom: domItems.map(el => ({ key: el.dataset.lineItemKey, qty: parseInt(el.dataset.quantity, 10) })),
          cart: cartRealItems.map(i => ({ key: i.key, qty: i.quantity })),
          mismatch: domItems
            .map(el => {
              const cartItem = cartRealItems.find(i => i.key === el.dataset.lineItemKey);
              return cartItem && cartItem.quantity !== parseInt(el.dataset.quantity, 10)
                ? { key: el.dataset.lineItemKey, domQty: parseInt(el.dataset.quantity, 10), cartQty: cartItem.quantity }
                : null;
            })
            .filter(Boolean)
        });
        const sectionIds = this.getSectionsToRender().map(s => s.section).filter(Boolean).join('&sections[]=');
        const freshSections = await fetch(`?sections[]=${sectionIds}`).then(r => r.json());
        this.renderNewSections(freshSections, false);
        if (DEBUG && onCartPage) console.log('[addShippingCategory] DOM synced — continuing with fresh elements');
      } else {
        if (DEBUG && onCartPage) console.log('[addShippingCategory] DOM is in sync', { count: domItems.length });
      }

      const updateProductObj = {
        updates: {},
        sections: this.getSectionsToRender().map((s) => s.section),
        sections_url: window.location.pathname,
      };

      updateProductObj.updates = items.map((item) => {
        if(item.properties && item.properties._shipping_category) {
          return { [item.key]: 0 };
        }
      });
      updateProductObj.updates = updateProductObj.updates.filter((item) => item !== undefined);
      updateProductObj.updates = updateProductObj.updates.reduce((acc, obj) => ({ ...acc, ...obj }), {});


      if (Object.keys(updateProductObj.updates).length > 0) {
        const deleteShippingCategoryItems = JSON.stringify(updateProductObj);
        await this.updateCartItems(deleteShippingCategoryItems);
      };


      // -------------------------------------
      // ここにカート更新処理を記述
        const itemList = document.querySelectorAll('.unico-cart-list-item');
        let shippingCategories = [];
        const cannotPurchasedSameTimeItems = this.setCannotPurchasedSameTimeItems(itemList);
        const canPurchasedSameTimeItems = this.setCanPurchasedSameTimeItems(itemList);
        // 配列からnullを除外
        const arrayWithoutNulls = canPurchasedSameTimeItems.filter(element => element !== null);

        // 重複を合わせる
        const canPurchasedSameTimeItemsV = this.mergeCanPurchasedSameTimeItems(arrayWithoutNulls);

        // 追加送料単位に分ける
        const shippingUnitCanPurchasedSameTimeItemsVItems = this.mergeAdditionalShippingUnit(canPurchasedSameTimeItemsV);
        console.log("------追加送料単位------");
        // shippingUnitCanPurchasedSameTimeItemsVItems.forEach((item) => console.log(item.properties))

        // 配送区分の統合チェックを実行
        const mergedItems = this.mergeDuplicateShippingCategories([...cannotPurchasedSameTimeItems, ...shippingUnitCanPurchasedSameTimeItemsVItems]);
        
        // 全く同じデータの配送区分の明細が分かれるようにする
        let itemsArr = mergedItems;
        itemsArr = itemsArr.map((item, index) => {
          const itemString = JSON.stringify(item);
          const sameItemIndex = itemsArr.findIndex((i, iIndex) => {
            return JSON.stringify(i) === itemString && index !== iIndex;
          });
          if(sameItemIndex !== -1) {
            item.properties._index = index;
          }
          return item;
        });

        if(itemsArr.length === 0) {
          WLCommon.disableLoading();
          const updateModal = document.querySelector('[data-target-id="cart-update-alert"] dialog');
          if (updateModal) {
            updateModal.close();
          }
          return;
        }

        const body = JSON.stringify({
          items: itemsArr,
          sections: this.getSectionsToRender().map((s) => s.section),
          sections_url: window.location.pathname,
        });
  
        try {
          const response = await fetch(`${theme.routes.cart_add_url}`, {
            ...fetchConfig(),
            ...{ body },
          }).then((r) => r.json());
          console.log("---------配送区分の追加実行---------");
          this.renderNewSections(response.sections, false);
          WLCommon.disableLoading();
          setTimeout(() => {
            const submitButtons = document.querySelectorAll('.unico-submit-button')
            const updateModal = document.querySelector('[data-target-id="cart-update-alert"] dialog');
            if(submitButtons.length) {
              submitButtons.forEach((submitButton) => {
                submitButton.disabled = false;
              });
              document.querySelectorAll('.unico-cart-list-item-button-area unico-counter-box').forEach((counter) => {
                counter.classList.remove('loading');
                WLCartUpdate.init();
              });
            }
            if(updateModal) {
              updateModal.close();
            }
          }, 1000);
        } catch(error) {
          WLCommon.disableLoading();
          console.log("---------配送区分の追加失敗---------");
          console.error("カート更新失敗", error);
        }
      } finally {
        this.shippingCategoryLock = false;
        // A call arrived while we held the lock — run once more with the now-current DOM.
        if (this.shippingCategoryRerun) {
          this.shippingCategoryRerun = false;
          this.addShippingCategory();
        }
      }
    },
    updateCartItems: function(body) {
      return new Promise((resolve, reject) => {
        fetch(`/cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: body,
        })
        .then((response) => response.json())
        .then((response) => {
          console.log("---------配送区分の削除---------");
          resolve();
        })
        .catch(() => {
          console.log("---------配送区分の削除失敗---------");
          this.errorCartUpdate();
        });
      });
    },
    mergeCanPurchasedSameTimeItems: (canPurchasedSameTimeItems) => {
      return canPurchasedSameTimeItems.reduce((acc, item) => {
        // 既存のアイテムを見つける
        const existingItem = acc.find(
            (i) =>
                i.properties._shipping_size === item.properties._shipping_size &&
                i.properties._shipping_vendor_code === item.properties._shipping_vendor_code &&
                i.properties._cannot_purchased_same_time === item.properties._cannot_purchased_same_time &&
                // 追加送料単位ありの商品は、同じ商品同士でしかまとめない（MISAWA_UNICO-409 2024-12-16 合意）。
                // 後から来た item 側だけでなく、既にある行（i）側も追加送料単位が無いことを条件にする。
                !i.properties._additional_shipping_unit &&
                !item.properties._additional_shipping_unit

        );
        if (existingItem) {
            // 既存のアイテムに対して処理をまとめる
            existingItem.properties["_target_variant_id"] += ',' + item.properties["_target_variant_id"];
            existingItem.properties["対象商品"] += ` / ${item.properties["対象商品"]}`; 
            existingItem.properties["_target_variant_count"] += ',' + item.properties["_target_variant_count"];
        } else {
            // 新しいアイテムとして追加
            acc.push({ ...item });
        }
    
        return acc;
      }, []);
    },
    mergeAdditionalShippingUnit: (items) => {
      return items.reduce((acc, item) => {
        if(!item.properties._additional_shipping_unit) {
          acc.push({...item});
          return acc;
        }
        const targetVariantCount = Number(item.properties._target_variant_count);
        const additionalShippingUnit = Number(item.properties._additional_shipping_unit);
        
        if (targetVariantCount > additionalShippingUnit) {
          const additionalShippingUnitCount = Math.ceil(targetVariantCount / additionalShippingUnit);
          let count = targetVariantCount;
          for (let i = 0; i < additionalShippingUnitCount; i++) {
            const newItem = { ...item, properties: { ...item.properties } };
            newItem.properties._index = i;
            newItem.properties._separated = true;
            newItem.properties._target_variant_count = count / additionalShippingUnit > 1 ? additionalShippingUnit : count; 
            acc.push(newItem);
            count -= additionalShippingUnit;
          }
          return acc
        } else {
          acc.push({...item});
          return acc;
        }
      }, []);
    },
    setCannotPurchasedSameTimeItems: (itemList) => {
      return Array.from(itemList).flatMap((item, index) => {
        if (item.dataset.shippingCategoryId && ( !item.dataset.cannotPurchasedSameTime || item.dataset.cannotPurchasedSameTime === 'false' )) {
          return Array.from({ length: parseInt(item.dataset.quantity, 10) }, (_, i) => ({
            id: item.dataset.shippingCategoryId,
            quantity: 1,
            properties: {
              _index: i,  // 1から始まるインデックス
              _shipping_category: true,
              _target_variant_id: item.dataset.lineItemKey,
              _shipping_size: item.dataset.shippingSize,
              _shipping_vendor_code: item.dataset.shippingVendorCode.trim(),
              _cannot_purchased_same_time: item.dataset.cannotPurchasedSameTime,
              _target_variant_count: 1,
              "対象商品": item.dataset.productTitle
            }
          }));
        }
        return [];  // 条件に合わない場合は空配列を返す
      });
    },
    setCanPurchasedSameTimeItems: (itemList) => {
      return Array.from(itemList).map((item) => {
        if (item.dataset.shippingCategoryId && item.dataset.cannotPurchasedSameTime === 'true') {
          // 条件に合致しない場合、新しいオブジェクトを返す
          return {
            id: item.dataset.shippingCategoryId,
            quantity: 1,
            properties: {
              _index: 0,
              _shipping_category: true,
              _target_variant_id: item.dataset.lineItemKey,
              _shipping_size: item.dataset.shippingSize,
              _shipping_vendor_code: item.dataset.shippingVendorCode.trim(),
              _cannot_purchased_same_time: item.dataset.cannotPurchasedSameTime,
              _additional_shipping_unit: item.dataset.additionalShippingUnit,
              _target_variant_count: item.dataset.quantity,
              "対象商品": item.dataset.productTitle
            }
          };
        }
        return null; 
      });
    },
    errorCartUpdate: (error) => {
      WLCommon.disableLoading();
      console.error("カート更新失敗", error);
    },
    removeCustomOrderChildItems: function(elem, json) {
      WLCommon.enableLoading();
      const updateProductObj = {
        updates: {},
        sections: this.getSectionsToRender().map((s) => s.section),
        sections_url: window.location.pathname,
      };
      updateProductObj.updates[elem.dataset.variantKey] = 0;
      for (const value of json) {
        updateProductObj.updates[value[0]] = value[1];
      }

      const body = JSON.stringify(updateProductObj);

      fetch(`${theme.routes.cart_update_url}`, {
        ...fetchConfig(),
        ...{ body },
      })
      .then((response) => response.json())
      .then((response) => {
        this.renderNewSections(response.sections);
      })
      .catch(() => {
        this.errorCartUpdate();
      })
      .finally(() => {
        WLCommon.disableLoading();
      })

    },

    deleteSinglePurchaseAvailableItems: async function() {
      const cartItems = document.querySelectorAll('.unico-cart-list-item');
      const singlePurchaseAvailableVariantIds = Array.from(cartItems).reduce((acc, item) => {
        const isSinglePurchaseAvailable = item.dataset.singlePurchaseAvailable;
        if (isSinglePurchaseAvailable === 'false' && item.dataset.setKey === 'false' ) {
          acc.push(item.dataset.variantId);
        }
        return acc;
      }, []);
      const otherItems = Array.from(cartItems).reduce((acc, item) => {
        const isSinglePurchaseAvailable = item.dataset.singlePurchaseAvailable;
        if (isSinglePurchaseAvailable === 'true' || item.dataset.setKey !== 'false') {
          acc.push(item.dataset.variantId);
        }
        return acc;
      }, []);

      if(otherItems.length === 0 && singlePurchaseAvailableVariantIds.length > 0) {
        WLCommon.enableLoading();
        const updateProductObj = {
          updates: {},
          sections: this.getSectionsToRender().map((s) => s.section),
          sections_url: window.location.pathname,
        };
        updateProductObj.updates[singlePurchaseAvailableVariantIds[0]] = 0;
        const updateResponse = await fetch(`${theme.routes.cart_update_url}`, {
          ...fetchConfig(),
          body: JSON.stringify(updateProductObj),
        }).then((res) => res.json());
        
        this.renderNewSections(updateResponse.sections);
        WLCommon.disableLoading();
      }
    },

    addEstimateItems: async function (estimateNo) {
      try { 
        const updateModal = document.querySelector('[data-target-id="cart-update-alert"] dialog');
        if (updateModal) {
          updateModal.showModal();
        }
    
        // 見積番号から見積情報を取得
        const url = '/apps/unico-kit3/store-estimate';
        const response = await fetch(url, {
          method: "POST",
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({estimate_code: estimateNo}),
        }).then((res) => res.json())
    
        // エラーチェック
        if (response.error.length) {
          response.error.sort((a, b) => a.type - b.type);
    
          for (const error of response.error) {
            switch (error.type) {
              case 1:
                document.querySelector('#estimate-error-box-type1').style.display = 'block';
                this.estimateErrorType1And5Products.push(error.product_code);
                return;
    
              case 2:
              case 3:
                this.estimateErrorType2And3Products.push(error.product_code);
                break;
    
              case 4:
                this.estimateErrorType4Products.push(error.product_code);
                break;

              case 5:
                document.querySelector('#estimate-error-box-type4').style.display = 'block';
                this.estimateErrorType1And5Products.push(error.product_code);
                return;

              case 6:
                this.estimateErrorType6Products.push(error.product_code);
                break;

            }
          }
        }
    
        if (response.product.length) {
          // 既存の見積情報がカートに入っている場合、削除
          const cartData = await fetch(`${theme.routes.cart_url}.js`).then((res) => res.json());
    
          const updateProductObj = {
            updates: {}
          };
          const updateProductIds = [];
          
          cartData.items.forEach((item) => {
            if (item.properties && item.properties._estimate_code) {
              updateProductObj.updates[item.key] = 0;
              updateProductIds.push(item.variant_id.toString());
            }
          });

          // 付随するギフト商品も削除
          cartData.items.forEach((item) => {
            if (item.properties && item.properties._is_gift_item && updateProductIds.includes(item.properties._target_product_id)) {
              updateProductObj.updates[item.key] = 0;
            }
          });
    
          if (Object.keys(updateProductObj.updates).length > 0) {
            const body = JSON.stringify(updateProductObj);
            const updateResponse = await fetch(`${theme.routes.cart_update_url}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body,
            }).then((res) => res.json());
            console.log("既存の見積削除");
            console.log(updateResponse.items);
          }
          
          // 新しい見積情報をカートに追加
          const estimateItems = response.product
            .filter(product => !this.buildPriceSKUs.includes(product.product_code)) // 現地組立料を除外
            .map((product, index) => ({
              id: product.variant_id,
              quantity: product.quantity,
              properties: {
                _estimate_code: estimateNo,
                _estimate_line_number: product.line_number,
                "見積番号": estimateNo,
              },
            }));
          
          // estimateItemsが空の場合は処理を終了
          if (estimateItems.length === 0) {
            console.log("見積連携：追加する商品がありません");
            this.showEstimateErrors();
            // URLパラメータの?estimate=をURLから削除
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.delete('estimate');
            window.history.replaceState({}, '', newUrl);
            return;
          }
          
          const body = JSON.stringify({
            items: estimateItems,
            sections: this.getSectionsToRender().map((s) => s.section),
            sections_url: window.location.pathname,
          });
          
          const addResponse = await fetch(`${theme.routes.cart_add_url}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body,
          }).then((res) => res.json());
          console.log("新規の見積追加");
          console.log(addResponse.items);

          const buildPriceItems = [];
          Object.values(addResponse.sections).forEach(sectionHtml => {
            const template = document.createElement('template');
            template.innerHTML = sectionHtml;
            const buildItems = template.content.querySelectorAll('.unico-cart-list-item[data-estimate-build-variant-id]');
            buildPriceItems.push(...Array.from(buildItems));
          });

          // 組立料金の追加処理
          if (buildPriceItems.length > 0) {
            // 対象商品行（line item key）と組立料行を 1:1 で安定して紐づけるため、見積連携時も _build_link_id を付与する
            const buildPriceTargetMappings = Array.from(buildPriceItems).map((item) => ({
              targetVariantId: String(item.dataset.variantId),
              targetLineItemKey: item.dataset.lineItemKey,
              buildPriceVariantId: String(item.dataset.estimateBuildVariantId),
              buildLinkId: this.generateBuildLinkId(),
              productTitle: item.dataset.productTitle,
            }));

            const buildPriceVariants = buildPriceTargetMappings.map((mapping) => ({
              id: mapping.buildPriceVariantId,
              quantity: 1,
              properties: {
                _estimate_code: estimateNo,
                _is_build_price: true,
                _variant_id: mapping.buildPriceVariantId,
                _build_target_variant: mapping.targetVariantId,
                _build_link_id: mapping.buildLinkId,
                "見積番号": estimateNo,
                "対象商品": mapping.productTitle,
              },
            }));

            const buildPriceBody = JSON.stringify({
              items: buildPriceVariants,
              sections: this.getSectionsToRender().map((s) => s.section),
              sections_url: window.location.pathname,
            });

            const buildPriceResponse = await fetch(`${theme.routes.cart_add_url}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: buildPriceBody,
            }).then((res) => res.json());
            console.log("組立料金の追加");
            console.log(buildPriceResponse.items);


            // 組立料金の対象商品に_build_price_targetを追加
            const updateEstimateItemsProperties = async (buildPriceTargetMappings) => {
              // buildPrice 追加後の最新 key / quantity を使って更新する（properties更新で key が変わる可能性があるため）
              const latestCart = await fetch(`${theme.routes.cart_url}.js`).then((res) => res.json());
              for (const mapping of buildPriceTargetMappings) {
                const targetLineItem = latestCart.items.find((cartItem) => cartItem.key === mapping.targetLineItemKey);
                if (!targetLineItem) {
                  console.warn(`estimate target line not found for key: ${mapping.targetLineItemKey}`);
                  continue;
                }

                const updatedProperties = {
                  ...targetLineItem.properties,
                  _build_price_target: mapping.buildPriceVariantId,
                  _build_link_id: mapping.buildLinkId,
                };

                const response = await fetch('/cart/change.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                  },
                  body: JSON.stringify({
                    id: targetLineItem.key,
                    quantity: targetLineItem.quantity,
                    properties: updatedProperties
                  })
                });

                if (!response.ok) {
                  this.errorCartUpdate(response);
                  return;
                }
              }
            };

            await updateEstimateItemsProperties(buildPriceTargetMappings);

            const sections = this.getSectionsToRender().map((s) => s.section).join("&sections[]=");
            const sectionsResponse = await fetch(`?sections[]=${sections}`).then((res) => res.json());
            this.renderNewSections(sectionsResponse);
          } else {
            this.renderNewSections(addResponse.sections);
          }
        } else {
          this.showEstimateErrors();
        }

        // URLパラメータの?estimate=をURLから削除
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.delete('estimate');
        window.history.replaceState({}, '', newUrl);
        
      } catch (error) {
        this.errorCartUpdate(error);
        alert("見積情報の取得に失敗しました");
      } finally {
        const updateModal = document.querySelector('[data-target-id="cart-update-alert"] dialog');
        if (updateModal) {
          updateModal.close();
        }
        WLCommon.disableLoading();
        return;
      }
    },
    
    checkEstimateProductPreOrder: async function() {
      if(this.estimateErrorType1And5Products.length) return;

      // DOMが更新されるまで少し待つ（見積連携後のDOM更新を待つ）
      await new Promise(resolve => setTimeout(resolve, 100));

      // カート以外のページや対象アイテムがない場合は、ローディングもネットワークリクエストも行わずに終了する
      const cartItems = document.querySelectorAll('.unico-cart-list-item');
      if (!cartItems.length) return;

      WLCommon.enableLoading();

      // カートAPIから最新のカートデータを取得
      const cartData = await this.getCart();

      const updateItems = [];

      cartItems.forEach((item) => {
        // wl-add-to-cart要素内のscript[type="application/json"]を取得
        const addToCartElement = item.querySelector('wl-add-to-cart');
        if (!addToCartElement) {
          console.log('[見積連携] wl-add-to-cart要素が見つかりません');
          return;
        }
        
        const json = addToCartElement.querySelector('script[type="application/json"]');
        if (!json) {
          console.log('[見積連携] JSONデータが見つかりません');
          return;
        }
        
        let variantData;
        try {
          variantData = JSON.parse(json.innerHTML);
        } catch (error) {
          console.error('[見積連携] JSON解析エラー:', error);
          return;
        }
        
        // 予約商品かどうかをチェック
        if ((variantData.quantity > 0) ||
              (variantData.quantity <= 0 && variantData.inventory_policy !== 'continue') ||
              (!variantData.stock_date || !variantData.delivery_buffer)) {
          return;
        }
  
        const today = new Date();
        let quantity = variantData.quantity;
        variantData.stock_date.sort((a, b) => {
          return new Date(a.date) - new Date(b.date);
        });
        for (let i = 0; i < variantData.stock_date.length; i++) {
          const stockDate = new Date(variantData.stock_date[i].date);
  
          if (!this.isNowDateAheadOfStockDate(today, stockDate)) continue;
          const stockAmount = variantData.stock_date[i].amount;
  
          quantity += stockAmount;
          if (quantity > 0) {
            const deliveryDate = this.getDeliveryDate(stockDate, variantData);
            const stockDateString = `${stockDate.getFullYear()}年${
              stockDate.getMonth() + 1
            }月${this.getDatePeriod(stockDate)}`;

            // カートAPIから取得したデータから既存のプロパティを取得
            const lineItemKey = item.dataset.lineItemKey;
            const cartItem = cartData.items.find(cartItem => cartItem.key === lineItemKey);
            const oldProperties = cartItem ? { ...cartItem.properties } : {};

            const newProperties = {
              _pre_order: true,
              _stock_date: stockDateString,
              _delivery_date: deliveryDate
            };
            const mergedProperties = { ...oldProperties, ...newProperties };

            updateItems.push({
              key: lineItemKey,
              properties: mergedProperties,
              quantity: parseInt(item.dataset.quantity, 10),
            });
            break;
          }
        }
        if (quantity <= 0) {
          return;
        }
      });

      if (updateItems.length === 0) {
        WLCommon.disableLoading();
        return;
      }

      const updateCartItemsProperties = async (updateItems) => {
        for (let item of updateItems) {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: item.key, 
              quantity: item.quantity,
              properties: item.properties
            })
          });

          if (!response.ok) {
            this.errorCartUpdate(response);
            return;
          }

          const result = await response.json();
        }
      };

      await updateCartItemsProperties(updateItems);

      const sections = this.getSectionsToRender().map((s) => s.section).join("&sections[]=");
      const sectionsResponse = await fetch(`?sections[]=${sections}`).then((res) => res.json());
      this.renderNewSections(sectionsResponse);

      WLCommon.disableLoading();
    },

    isNowDateAheadOfStockDate: function(nowDate, stockDate) {
      return this.convertDateToPeriodStart(nowDate).getTime() < this.convertDateToPeriodStart(stockDate).getTime();
    },

    convertDateToPeriodStart: function(date) {
      const year = date.getFullYear();
      const month = date.getMonth();
      const day = date.getDate();
      let newDay = day <= 10 ? 1 : (day <= 20 ? 11 : 21);
      return new Date(year, month, newDay);
    },

    getDeliveryDate: function(date, currentVariant) {
      let deliveryDate = new Date(date);
      if (currentVariant.delivery_buffer.key === 'month') {
          deliveryDate.setMonth(deliveryDate.getMonth() + Number(currentVariant.delivery_buffer.period));
      } else if (currentVariant.delivery_buffer.key === 'date') {
          deliveryDate.setDate(deliveryDate.getDate() + Number(currentVariant.delivery_buffer.period));
      }

      let year = deliveryDate.getFullYear().toString();
      let month = (deliveryDate.getMonth() + 1).toString();
      let settingsDeliveryText = this.getDatePeriod(deliveryDate);

      return `${year}年${month}月${settingsDeliveryText}`;
    },

    getDatePeriod: function(date) {
      const day = date.getDate();
      return day <= 10 ? "上旬" : day <= 20 ? "中旬" : "下旬";
    },

    showEstimateErrors: function() {
      if (this.estimateErrorType2And3Products.length) {
        document.querySelector('#estimate-error-message-type2').innerText = document
          .querySelector('#estimate-error-message-type2')
          .innerText.replace('[productNumber]', this.estimateErrorType2And3Products.join(', '));
        document.querySelector('#estimate-error-box-type2').style.display = 'block';
      }

      if (this.estimateErrorType4Products.length) {
        document.querySelector('#estimate-error-message-type3').innerText = document
          .querySelector('#estimate-error-message-type3')
          .innerText.replace('[productNumber]', this.estimateErrorType4Products.join(', '));
        document.querySelector('#estimate-error-box-type3').style.display = 'block';
      }
      if (this.estimateErrorType6Products.length) {
        document.querySelector('#estimate-error-message-type6').innerText = document
          .querySelector('#estimate-error-message-type6')
          .innerText.replace('[productNumber]', this.estimateErrorType6Products.join(', '))
          .replace(/\s+/g, ' ');
        document.querySelector('#estimate-error-box-type6').style.display = 'block';
      }
    },
    mergeDuplicateShippingCategories: (items) => {
      return items.reduce((acc, item) => {
        // 既存のアイテムを見つける（順番を無視して全く同じ内容かチェック）
        const existingItem = acc.find((existing) => {
          // 基本プロパティの比較
          if (existing.id !== item.id ||
              existing.quantity !== item.quantity) {
            return false;
          }

          // propertiesの比較（順番を無視）
          const existingProps = existing.properties;
          const newProps = item.properties;

          // プロパティのキーが同じかチェック
          const existingKeys = Object.keys(existingProps).sort();
          const newKeys = Object.keys(newProps).sort();
          if (existingKeys.join(',') !== newKeys.join(',')) {
            return false;
          }

          // 各プロパティの値を比較（順番を無視）
          for (const key of existingKeys) {
            const existingValue = existingProps[key];
            const newValue = newProps[key];

            // 配列やカンマ区切り文字列の場合は正規化して比較
            if (typeof existingValue === 'string' && typeof newValue === 'string') {
              if (existingValue.includes(',') || existingValue.includes(' / ')) {
                // カンマ区切りまたはスラッシュ区切りの場合は正規化
                const existingNormalized = existingValue.split(/[,/]/).map(v => v.trim()).sort().join(',');
                const newNormalized = newValue.split(/[,/]/).map(v => v.trim()).sort().join(',');
                if (existingNormalized !== newNormalized) {
                  return false;
                }
              } else {
                // 通常の文字列比較
                if (existingValue !== newValue) {
                  return false;
                }
              }
            } else {
              // その他の型の比較
              if (existingValue !== newValue) {
                return false;
              }
            }
          }

          return true;
        });

        if (!existingItem) {
          // 新しいアイテムとして追加
          acc.push({ ...item });
        } else {
          console.log("既存のアイテムが見つかったので1つに統合");
          console.log(existingItem);
          console.log(item);
        }
        // 既存のアイテムが見つかった場合は何もしない（1つだけ残す）
        return acc;
      }, []);
    }
};

window.WLCart = WLCart;

document.addEventListener("DOMContentLoaded", function() {
  WLCart.deleteShippingCategory().then(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('estimate')) {
      // 見積連携: 見積番号で商品追加後に予約判定
      WLCart.addEstimateItems(urlParams.get('estimate')).then(() => {
        WLCart.checkEstimateProductPreOrder();
      });
    } else {
      // 見積連携でない場合も、カートに見積・予約商品があれば「今日」で再計算する（商品詳細と表示を揃える）
      WLCart.checkEstimateProductPreOrder();
    }
  });
});